import { render } from "./SubmissionStatusChart.vue?vue&type=template&id=18570f18&ts=true"
import script from "./SubmissionStatusChart.vue?vue&type=script&lang=ts"
export * from "./SubmissionStatusChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__